// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body{font-family:-apple-system,BlinkMacSystemFont,PingFang SC,Helvetica,Tahoma,Arial,Microsoft YaHei,微软雅黑,黑体,Heiti,sans-serif,SimSun,宋体,serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;height:100%;padding:0;margin:0}#app{height:100vh}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
